export enum HomeHeroCardStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}
